import React, { Component } from 'react';
import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import axios from 'axios';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import TextField from '@mui/material/TextField';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import logoImage from './images/logo.jpg';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Select from '@mui/material/Select';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import psdfimage from './images/psdfimage.png';
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}
function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 const headCellsSummary = [
  { id: 'le_ledgername', numeric: false, label: 'Ledger Name' },
  { id: 'le_code', numeric: false, label: 'Code' },
  { id: 'opening_balance', numeric: true, label: 'Opening' },
  { id: 'total_debit', numeric: true, label: 'Debit' },
  { id: 'total_credit', numeric: true, label: 'Credit' },
  { id: 'closing_balance', numeric: true, label: 'Closing' },
];
 const headCellsDetail = [
  { id: 'tr_date', numeric: false, label: 'Date' },
  { id: 'tr_ref_type', numeric: false, label: 'Type' },
  { id: 'tr_ref_id', numeric: false, label: 'Ref ID' },
  { id: 'jr_debit', numeric: true, label: 'Debit' },
  { id: 'jr_credit', numeric: true, label: 'Credit' },
  { id: 'tr_comments', numeric: false, label: 'Comments' },
];
const styles = {
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  expandRow: {
    backgroundColor: '#f5f5f5',
  },
};
export default class TransactionsLedgerReport extends Component {
  constructor(props) {
    super();
    const currentDate = new Date();
    const month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
    const lastDay = (new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate() < 10)
      ? "0" + new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate()
      : new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
    this.state = {
      logredirect: false,
      pagename: '',
      page: 0,
      prevpage: 0,
      totaldata: 0,
      rowsPerPage: 10,
      rowsPaging: [],
      search: '',
      id: '',
      order: 'asc',
      orderBy: 'le_ledgername',
      ledgerdata: [],                             
      detailData: {},                             
      expandedLedger: [],                       
      openExportDialog: false,
      fromdate: dayjs(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)),
      fromdate1: currentDate.getFullYear() + '-' + month1 + '-' + '01',
      todate: dayjs(currentDate),
      todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay,
      fromDateEnabled: false,
      toDateEnabled: false,
      cmp_id: '',                                
    };
  }
  myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;
    this.setState({ [nam]: val });
  };
  componentWillMount() {
    document.title = "Isifol - General Ledger Report";
    const cmpId = localStorage.getItem("ISIcmpid") || 1;
    this.setState({ cmp_id: cmpId }, () => {
      this.fetchReportData(this.state.page, this.state.rowsPerPage);
    });
    this.props.parentdasCallback("General Ledger Report~");
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.cmp_id !== this.state.cmp_id ||
      prevState.fromdate1 !== this.state.fromdate1 ||
      prevState.todate1 !== this.state.todate1 ||
      prevState.page !== this.state.page ||
      prevState.rowsPerPage !== this.state.rowsPerPage
    ) {
      this.fetchReportData(this.state.page, this.state.rowsPerPage);
    }
  }
fetchReportData = (page, rowsPerPage) => {
  const { fromdate1, todate1, cmp_id, order, orderBy } = this.state;
  const orderByParam = `${orderBy} ${order === 'desc' ? 'DESC' : 'ASC'}`;
  const apiUrl =
    localStorage.getItem("ISIurl") +
    'ajaxledger.php?' +
    'action=generalledtransreportsummary&' +
    'fromdate=' + fromdate1 + '&' +
    'todate=' + todate1 + '&' +
    'cmp_id=' + cmp_id + '&' +
    'StartIndex=' + page + '&' +
    'PageSize=' + rowsPerPage + '&' +
    'orderBy=' + encodeURIComponent(orderByParam);
  axios
    .get(apiUrl)
    .then(resp => {
      const rows = resp.data || [];
      if (rows.length > 0) {
        this.setState({
          ledgerdata: rows,
          totaldata: parseInt(rows.length),
          detailData: {},
        });
      } else {
        this.setState({
          ledgerdata: [],
          totaldata: 0,
          detailData: {},
        });
      }
    })
    .catch(error => {
      console.error("Error fetching ledger summary:", error);
      this.setState({
        ledgerdata: [],
        totaldata: 0,
        detailData: {},
      });
    });
};
getChildLink = (item) => {
  const id = item.main_doc_id;
  const type = item.doc_category;
  if (!id || !type) return null;
  switch (type) {
    case "SalesInvoice":
      return `#/Salesinvoiceviewmore?sinoid=${id}`;
    case "SalesCreditNote":
      return `#/Salecreditnoteviewmore?scnoid=${id}`;
    case "VendorBill":
      return `#/vendorbillviewmore?vbid=${id}`;
    case "VendorCreditNote":
      return `#/Vendorcreditnoteviewmore?vcnid=${id}`;
    default:
      return null;
  }
};
fetchLedgerDetails = (ledger) => {
  const le_id = ledger.le_id;
  const le_code = ledger.le_code;
   if (this.state.detailData[le_id]) {
    return;
  }
  const { fromdate1, todate1 } = this.state;
  const cmpId = localStorage.getItem("ISIcmpid");  
  const apiUrl =
    localStorage.getItem("ISIurl") +
    'ajaxledger.php?' +
    'action=generalledtransreport&' +
    'fromdate=' + fromdate1 + '&' +
    'todate=' + todate1 + '&' +
    'cmp_id=' + cmpId + '&' +
    'ledger_id=' + le_code + '&' +
    'StartIndex=0&' +
    'PageSize=1000&' +
    'orderBy=tr_date DESC';
  axios
    .get(apiUrl)
    .then(resp => {
      const transactionRows = resp.data || [];
      this.setState(prev => ({
        detailData: {
          ...prev.detailData,
          [le_id]: transactionRows,
        },
      }));
    })
    .catch(error => {
      console.error("Error fetching ledger details:", error);
      this.setState(prev => ({
        detailData: {
          ...prev.detailData,
          [le_id]: [],
        },
      }));
    });
};
handleToggleLedger = (ledger) => {
  const { expandedLedger } = this.state;
  const le_id = ledger.le_id;
  if (expandedLedger.includes(le_id)) {
     this.setState({
      expandedLedger: expandedLedger.filter(id => id !== le_id)
    });
  } else {
     this.fetchLedgerDetails(ledger);
    this.setState({
      expandedLedger: [...expandedLedger, le_id]
    });
  }
};
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };
  handleChangeRowsPerPage = event => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
      prevpage: -1,
    });
  };
  fromdatehandler = (date) => {
    if (date) {
      this.setState({
        fromdate: date,
        fromdate1: date.format('YYYY-MM-DD'),
        fromDateEnabled: true,
      });
    }
  };
  todatehandler = (date) => {
    if (date) {
      this.setState({
        todate: date,
        todate1: date.format('YYYY-MM-DD'),
        toDateEnabled: true,
      });
    }
  };
  onchangedateHandler = (event) => {
    const selectedOption = event.target.value;
    const periodMap = {
      'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
      'This Quarter': [dayjs().startOf('quarter'), dayjs().endOf('quarter')],
      'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
      'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
      'Last Quarter': [dayjs().subtract(1, 'quarter').startOf('quarter'), dayjs().subtract(1, 'quarter').endOf('quarter')],
      'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
    };
    if (selectedOption === 'Custom') {
      this.setState({
        fromdate: dayjs(),
        todate: dayjs().endOf('month'),
        fromdate1: dayjs().format('YYYY-MM-DD'),
        todate1: dayjs().endOf('month').format('YYYY-MM-DD'),
        fromDateEnabled: true,
        toDateEnabled: true,
      });
    } else {
      this.setState({
        fromdate: periodMap[selectedOption][0],
        todate: periodMap[selectedOption][1],
        fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
        todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
        fromDateEnabled: false,
        toDateEnabled: false,
      });
    }
  };
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      orderBy: property,
      order: isAsc ? 'desc' : 'asc',
    });
  };
handleDownload = () => {
  const { ledgerdata, detailData, expandedLedger } = this.state;
  const doc = new jsPDF();
  const getRefNo = (d) => {
    return d.ref_no && d.ref_no.trim() ? d.ref_no : "-";
  };
  const allRows = [];
  ledgerdata.forEach(row => {
    allRows.push([
      row.le_ledgername,
      row.le_code,
      parseFloat(row.opening_balance || 0).toFixed(2),
      parseFloat(row.total_debit || 0).toFixed(2),
      parseFloat(row.total_credit || 0).toFixed(2),
      parseFloat(row.closing_balance || 0).toFixed(2),
    ]);
    if (expandedLedger.includes(row.le_id)) {
      const details = detailData[row.le_id] || [];
      details.forEach(d => {
        allRows.push([
          `   ${dayjs(d.tr_date).format('MM-DD-YYYY')}`,
          `${getRefNo(d)} - ${d.tr_ref_type}`,
          "",
          parseFloat(d.total_debit || 0).toFixed(2),
          parseFloat(d.total_credit || 0).toFixed(2),
          d.tr_comments || '',
        ]);
      });
    }
  });
  doc.autoTable({
    head: [['Ledger', 'Code / Type', 'Opening', 'Debit', 'Credit', 'Closing']],
    body: allRows,
    styles: {
      fontSize: 9,
      cellPadding: 2,
    },
    didParseCell: function (data) {
       if (typeof data.cell.raw === "string" && data.cell.raw.startsWith("   ")) {
        data.cell.styles.textColor = [80, 80, 80];
      }
    }
  });
  doc.save('GLReport.pdf');
};
  handleOpenExportDialog = () => {
    this.setState({ openExportDialog: true });
  };
  handleCloseExportDialog = () => {
    this.setState({ openExportDialog: false });
  };
  render() {
    const {
      ledgerdata,
      detailData,
      expandedLedger,
      order,
      orderBy,
      page,
      rowsPerPage,
      totaldata,
      fromdate,
      todate,
      fromDateEnabled,
      toDateEnabled,
      openExportDialog,
    } = this.state;
    const stableSortedData = stableSort(ledgerdata, getSorting(order, orderBy));
     return (
      <React.Fragment>
        <div className="searchbox">
          <ul>
            <li>
              <p>Period</p>
              <p>
                <Select
                  native
                  variant="outlined"
                  className="txtbox"
                  margin="normal"
                  fullWidth
                  onChange={this.onchangedateHandler}
                  inputProps={{ tabIndex: "4" }}
                >
                  <option>This Month</option>
                  <option>This Quarter</option>
                  <option>This Year</option>
                  <option>Last Month</option>
                  <option>Last Quarter</option>
                  <option>Last Year</option>
                  <option>Custom</option>
                </Select>
              </p>
            </li>
            <li>
              <p>From Date</p>
              <p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker
                      disabled={!fromDateEnabled}
                      value={fromdate}
                      className="txtbox"
                      onChange={this.fromdatehandler}
                      format="MM/DD/YYYY"
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </p>
            </li>
            <li>
              <p>To Date</p>
              <p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker
                      disabled={!toDateEnabled}
                      value={todate}
                      className="txtbox"
                      onChange={this.todatehandler}
                      format="MM/DD/YYYY"
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </p>
            </li>
            <li>
              <p>&nbsp;</p>
              <p>
                <Button
                  type="button"
                  variant="contained"
                  className="frmSecondarybtn"
                  onClick={() => this.fetchReportData(0, rowsPerPage)}
                >
                  Calculate
                </Button>
                &nbsp;
                <Button
                  variant="contained"
                  color="primary"
                  className="exportbtn"
                  onClick={this.handleOpenExportDialog}
                >
                  EXPORT
                </Button>
              </p>
            </li>
          </ul>
        </div>
        <div className="clear"></div>
        <Paper className={styles.root}>
          <TableContainer className={styles.container}>
            <Table stickyHeader aria-label="sticky table" id="ledgerreporttable">
              <TableHead>
                <TableRow>
                  {headCellsSummary.map(headCell => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.numeric ? 'right' : 'left'}
                      padding="normal"
                      sortDirection={orderBy === headCell.id ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={event => this.handleRequestSort(event, headCell.id)}
                      >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                          <span className={styles.visuallyHidden}>
                            {order === 'desc' ? '  ' : '  '}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {stableSortedData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={headCellsSummary.length} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  stableSortedData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
					                    .map((row) => {
const isExpanded = expandedLedger.includes(row.le_id);
                      const details = detailData[row.le_id] || [];
                      return (
                        <React.Fragment key={row.le_id}>
                           <TableRow hover onClick={() => this.handleToggleLedger(row)}>
                            <TableCell>{row.le_ledgername}</TableCell>
                            <TableCell>{row.le_code}</TableCell>
                            <TableCell align="right">
                              {'\u200B' + parseFloat(row.opening_balance || 0).toFixed(2)}
                            </TableCell>
                            <TableCell align="right">
                              {'\u200B' + parseFloat(row.total_debit || 0).toFixed(2)}
                            </TableCell>
                            <TableCell align="right">
                              {'\u200B' + parseFloat(row.total_credit || 0).toFixed(2)}
                            </TableCell>
                            <TableCell align="right">
                              {'\u200B' + parseFloat(row.closing_balance || 0).toFixed(2)}
                            </TableCell>
                          </TableRow>
                          {/* EXPANDED DETAIL ROW */}
                          {isExpanded && (
                            <TableRow>
                              <TableCell colSpan={headCellsSummary.length}>
                                <div style={{ padding: 10, background: "#f9f9f9" }}>
                                 {details.length === 0 ? (
  <p>No transactions found</p>
) : (
  <Table
    style={{
      width: "98%",
      margin: "auto",
      tableLayout: "fixed"    
    }}
    size="small"
  >
    <TableHead>
      <TableRow>
        <TableCell style={{ width: "15%" }}>Date</TableCell>
        <TableCell style={{ width: "10%" }}>Ref</TableCell>
		<TableCell style={{ width: "20%" }}>Type</TableCell>
        <TableCell style={{ width: "10%" }} align="right">
          Debit
        </TableCell>
        <TableCell style={{ width: "10%" }} align="right">
          Credit
        </TableCell>
        <TableCell style={{ width: "10%" }}>
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {details.map((d, i) => (
        <TableRow
          key={i}
          hover
          style={{
            cursor: this.getChildLink(d) ? "pointer" : "default",
            background: "#f9f9f9"
          }}
          onClick={() => {
            const link = this.getChildLink(d);
            if (link) window.location.href = link;
          }}
        >
          <TableCell>
            {dayjs(d.tr_dep_store_date).isValid()
              ? dayjs(d.tr_date).format("MM-DD-YYYY")
              : d.tr_date}
          </TableCell>
          <TableCell>
            {(d.ref_no?.trim() ? d.ref_no : "-")}  
          </TableCell>
		  <TableCell>
             {d.tr_ref_type}
          </TableCell>
          <TableCell align="right">
	 {`'${parseFloat(d.total_debit || 0).toFixed(2)}`}
          </TableCell>
          <TableCell align="right">
            {`'${parseFloat(d.total_credit || 0).toFixed(2)}`}
          </TableCell>
          <TableCell>
           </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
)}
                                </div>
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      );
                    })
                )}
              </TableBody>
            </Table>
          </TableContainer>
           <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={totaldata}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>
<Dialog
  open={this.state.openExportDialog}
  onClose={this.handleCloseExportDialog}
>
  <DialogTitle>Generated Transactions Ledger report</DialogTitle>
  <DialogContent>
    <p>
      Choose a format you want to export:
    </p>
    <p
      style={{
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        gap: "20px",
      }}
    >
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="my-custom-excel-button"
        table="ledgerreporttable"
        filename="Transactions Ledger Report"
        sheet="Transactions Ledger Report"
        buttonText=" "
      />
      <img
        src={psdfimage}
        width={100}
        height={100}
        style={{ cursor: "pointer" }}
        onClick={this.handleDownload}
        alt="Download PDF"
      />
    </p>
  </DialogContent>
  <DialogActions>
    <Button onClick={this.handleCloseExportDialog} color="primary">
      Cancel
    </Button>
  </DialogActions>
</Dialog>
      </React.Fragment>
    );
  }
}